module.exports = "/_next/static/resources/blavka-2-56266c93261869eb5935ca5bc276f9a9.webp";